import { getCredential } from "../helpers/CommonHelper";

class EncryptionService {
    ENABLED_PAYLOAD_ENCRYPTION = true;

    Crypto = require("crypto-js");
    // ClientJS = require('clientjs');
    NodeRSA = require("node-rsa");
    // key = new this.NodeRSA({b: 4096});
    key = new this.NodeRSA({b:1024});

    _initKey() {
        let credentials = getCredential();
        let publicKey = credentials.serverPublicKey;
        // console.log("PK-Start: ", new Date());
        this.key.importKey(publicKey, "pkcs8-public-pem");
        // console.log("PK-Start: ", new Date());
    }

    _encryptByPairKey(payload) {
        if (payload === undefined || payload == null) {
            return payload;
        } else {
            // console.log("P-Start: ", new Date());
            this._initKey();
            let encrypted = this.key.encrypt(payload, "base64", "utf8");
            // console.log("P-End: ", new Date());
            return encrypted;
        }
    }

    _encryptBySecretKey(key, payload) {
        if (payload === undefined || payload == null) {
            return payload;
        } else {
            console.log("S-Start: ", new Date());
            let encoded = this.Crypto.AES.encrypt(payload, key).toString();
            let encrypted = encoded;
            // console.log("S-End: ", new Date(), encrypted);
            // let decoded = this.Crypto.AES.decrypt(encoded, key);
            // console.log("S_D: ", decoded.toString(this.Crypto.enc.Utf8));
            return encrypted;
        }
    }

    _extractBody(config) {
        // console.log("Payload: ", config.data);
        let payload;
        if (config.data === undefined || JSON.stringify(config.data).trim().length === 0) {
            payload = config.params !== undefined ? JSON.stringify(config.params["data"]) : undefined;
        } else {
            payload = JSON.stringify(config.data);
        }
        return payload;
    }

    encryptPayload(config) {
        // console.log("Start: ", new Date());
        let credentials = getCredential();
        let sessionKey = credentials.sessionKey;
        let payload = this._extractBody(config);
        let iv = "12345678";
        let encoded = this._encryptBySecretKey(sessionKey, payload);
        let data = {
            "data": encoded,
            "sessionKey": sessionKey,
            "iv": iv
        };
        data = this._encryptByPairKey(
            payload === undefined ? payload :
                JSON.stringify(data));
        config.data = {data};
        // console.log("End: ", new Date());
        return config;
    }
}

export default new EncryptionService();